import AuthAPI from "../apis/auth/AuthAPI";

const authAPI = new AuthAPI();

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// La raison est facultative : seul l'e-mail est validé.
export const validateUnsubscribe = ({ email }) => {
  const errors = {};
  if (!email.trim()) errors.email = "Veuillez saisir votre adresse e-mail.";
  else if (!EMAIL_REGEX.test(email.trim()))
    errors.email = "Cette adresse e-mail n'est pas valide.";
  return errors;
};

export const unsubscribe = async ({ email, reason }) => {
  try {
    await authAPI.putUnsubscribe({
      email: email.trim(),
      reason: reason.trim() || undefined, // omis du body si vide
    });
    return { ok: true };
  } catch (err) {
    const status = err?.response?.status;
    if (status === 422)
      return { ok: false, message: "Les informations saisies sont invalides. Vérifiez-les et réessayez." };
    if (status === 400 || status === 404)
      return { ok: false, message: "Aucun abonnement n'est associé à cette adresse e-mail." };
    return { ok: false, message: "Une erreur est survenue. Veuillez réessayer dans quelques instants." };
  }
};